"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerScrolls = exports.rollScrollVariants = exports.getRandomScrollVariant = exports.findScrollVariantComboByType = exports.scrollVariantCombos = void 0;
var ROT = __importStar(require("rot-js"));
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var rogueAanimManager_sidecar_1 = require("../anims/rogueAanimManager-sidecar");
var rogueSpellData_sidecar_1 = require("../anims/rogueSpellData-sidecar");
var rogueSpellTeleport_sidecar_1 = require("../anims/rogueSpellTeleport-sidecar");
var rogueSpell_blueprint_sidecar_1 = require("../anims/rogueSpell_blueprint-sidecar");
var rogueSpell_detectFire_sidecar_1 = require("../anims/rogueSpell_detectFire-sidecar");
var rogueSpell_detectLiving_sidecar_1 = require("../anims/rogueSpell_detectLiving-sidecar");
var rogueSpell_fire_sidecar_1 = require("../anims/rogueSpell_fire-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueCursor_1 = require("../ui/rogueCursor");
var rogueCursor_sidecar_1 = require("../ui/rogueCursor-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueItemsData_1 = require("./rogueItemsData");
var rogueItemsData_sidecar_1 = require("./rogueItemsData-sidecar");
var _scrollVariants = [];
var _createVariants = function () {
    if (_scrollVariants.length !== 0) {
        return;
    }
    _scrollVariants.push({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        name: 'READ ME',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    }, {
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        name: 'Lorem Ipsum',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    }, {
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        name: 'AUTOEXEC.BAT',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    }, {
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        name: 'FOOBIE BLETCH',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    }, {
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        name: 'Zorkmids',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    }, {
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        name: 'Yargle Glargle',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    }, {
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        name: 'Burn after Reading',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    });
};
exports.scrollVariantCombos = [];
var findScrollVariantComboByType = function (type) {
    var combo = exports.scrollVariantCombos.find(function (c) { return c.data.type === type; }) || null;
    assert_sidecar_1.assert.notNil(combo, "findScrollVariantComboByType: combo not found for type ".concat(type));
    return combo;
};
exports.findScrollVariantComboByType = findScrollVariantComboByType;
var getRandomScrollVariant = function () {
    var items = {};
    exports.scrollVariantCombos.forEach(function (c) {
        items[c.data.type] = c.data.spawnChance;
    });
    var type = ROT.RNG.getWeightedValue(items) || '?';
    var combo = (0, exports.findScrollVariantComboByType)(type);
    return combo;
};
exports.getRandomScrollVariant = getRandomScrollVariant;
var rollScrollVariants = function () {
    _createVariants();
    var variantsCopy = _scrollVariants.map(function (c) { return c; });
    variantsCopy = rando_sidecar_1.rando.shuffle(variantsCopy);
    rando_sidecar_1.rando.clearArray(exports.scrollVariantCombos);
    rogueItemsData_sidecar_1.rogueItemsData.dataListScrolls.forEach(function (c) {
        var v = rando_sidecar_1.rando.sampleAndRemove(variantsCopy);
        exports.scrollVariantCombos.push({
            variant: v,
            data: c,
            isIdentified: false,
        });
    });
};
exports.rollScrollVariants = rollScrollVariants;
var registerScrolls = function () {
    (0, rogueItemsData_1.registerItemData)({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        type: 'scroll-fire',
        description: 'A scroll of fire',
        name: 'scroll of fire',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
        isBurnable: true,
        onUse: function (item) {
            rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueSpell_fire_sidecar_1.rogueSpell_fire.rogueAnim());
            (0, rogueItemsData_1.tryIdentify)(item);
        },
    });
    (0, rogueItemsData_1.registerItemData)({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        type: 'scroll-teleport',
        description: 'A scroll of teleport',
        name: 'scroll of teleport',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
        isBurnable: true,
        onUse: function (item) {
            rogueCursor_sidecar_1.rogueCursor.setTargetMode(rogueCursor_1.ERogueTargetMode.spellTarget, rogueSpellTeleport_sidecar_1.rogueSpellTeleport.getSpellData());
            (0, rogueItemsData_1.tryIdentify)(item);
        },
    });
    (0, rogueItemsData_1.registerItemData)({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        type: 'scroll-blueprint',
        description: 'A scroll of blueprint',
        name: 'scroll of blueprint',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
        isBurnable: true,
        onUse: function (item) {
            rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueSpell_blueprint_sidecar_1.rogueSpell_blueprint.rogueAnim());
            (0, rogueItemsData_1.tryIdentify)(item);
        },
    });
    (0, rogueItemsData_1.registerItemData)({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        type: 'scroll-detect-living',
        description: 'A scroll of detect living',
        name: 'scroll of detect living',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
        isBurnable: true,
        onUse: function (item) {
            rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueSpell_detectLiving_sidecar_1.rogueSpell_detectLiving.rogueAnim());
            (0, rogueItemsData_1.tryIdentify)(item);
        },
    });
    (0, rogueItemsData_1.registerItemData)({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        type: 'scroll-detect-fire',
        description: 'A scroll of detect fire',
        name: 'scroll of detect fire',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
        isBurnable: true,
        onUse: function (item) {
            rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueSpell_detectFire_sidecar_1.rogueSpell_detectFire.rogueAnim());
            (0, rogueItemsData_1.tryIdentify)(item);
        },
    });
    (0, rogueItemsData_1.registerItemData)({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        type: 'scroll-replenish',
        description: 'A scroll of replenishment',
        name: 'scroll of replenishment',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
        isBurnable: true,
        onUse: function (item) {
            //rogueAanimManager.addAnim(rogueSpell_detectLiving.rogueAnim())
            rogueSpellData_sidecar_1.rogueSpellData.refreshAllSpells();
            (0, rogueItemsData_1.tryIdentify)(item);
        },
    });
    (0, rogueItemsData_1.registerItemData)({
        group: rogueItemsData_1.ERogueItemGroup.scroll,
        type: 'scroll-health',
        description: 'A scroll of health',
        name: 'scroll of health',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
        isBurnable: true,
        onUse: function (item) {
            var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
            if (p) {
                rogueStats_sidecar_1.rogueStats.setMessage('You feel better');
                rogueMonsters_sidecar_1.rogueMonsters.damage(p, -10, 'heal');
            }
            (0, rogueItemsData_1.tryIdentify)(item);
        },
    });
};
exports.registerScrolls = registerScrolls;
